import { css } from 'lit';
export const errorClassName = css `hlx-form-control-has-error`;
export const formControlStyles = css `
    /* === Label === */
    .hlx-form-control .hlx-form-control-label {
        display: none;
        color: var(--hlx-input-label-color-default);
        font-weight: var(--hlx-input-label-font-weight);
        line-height: var(--hlx-text-line-height-tight-1);
        margin-bottom: var(--hlx-spacing-xs);
    }
    .hlx-form-control-sm .hlx-form-control-label {
        font-size: var(--hlx-input-font-size-sm);
    }
    .hlx-form-control-md .hlx-form-control-label {
        font-size: var(--hlx-input-font-size-md);
    }
    .hlx-form-control-lg .hlx-form-control-label {
        font-size: var(--hlx-input-font-size-lg);
    }
    .hlx-form-control-label.hlx-form-control-label-disabled {
        color: var(--hlx-input-label-color-disabled);
    }

    .hlx-form-control-has-label .hlx-form-control-label {
        display: inline-block;
    }

    /* === Errors === */
    .hlx-form-control .hlx-form-control-error {
        display: none;
        color: var(--hlx-input-error-text-color);
        margin-top: var(--hlx-spacing-xs);
    }
    .hlx-form-control-error-icon {
        display: block;
        margin-right: var(--hlx-spacing-xs);
        margin-top: 1px;
    }
    .hlx-form-control-sm .hlx-form-control-error {
        font-size: var(--hlx-input-error-text-font-size-sm);
        line-height: var(--hlx-text-line-height-tight-2);
    }
    .hlx-form-control-md .hlx-form-control-error {
        font-size: var(--hlx-input-error-text-font-size-md);
        line-height: var(--hlx-text-line-height-tight-2);
    }
    .hlx-form-control-lg .hlx-form-control-error {
        font-size: var(--hlx-input-error-text-font-size-lg);
        line-height: var(--hlx-text-line-height-tight-2);
    }

    ::slotted(hlx-error-mapping) {
        display: none;
    }
    ::slotted(hlx-error-mapping.active-mapping) {
        display: block;
    }

    .hlx-form-control-has-active-mapping .error-text {
        display: none;
    }

    .${errorClassName} .hlx-form-control-error {
        display: flex;
    }

    /* === Help Text === */
    .hlx-form-control .hlx-form-control-help-text {
        display: none;
        color: var(--hlx-input-help-text-color);
        margin-top: var(--hlx-spacing-xs);
    }
    .hlx-form-control-help-text.hlx-form-control-help-text-disabled {
        color: var(--hlx-input-text-color-disabled);
    }
    .hlx-form-control-sm .hlx-form-control-help-text {
        font-size: var(--hlx-input-help-text-font-size-sm);
        line-height: var(--hlx-text-line-height-tight-2);
    }
    .hlx-form-control-md .hlx-form-control-help-text {
        font-size: var(--hlx-input-help-text-font-size-md);
        line-height: var(--hlx-text-line-height-tight-2);
    }
    .hlx-form-control-lg .hlx-form-control-help-text {
        font-size: var(--hlx-input-help-text-font-size-lg);
        line-height: var(--hlx-text-line-height-tight-2);
    }

    .hlx-form-control-has-help-text .hlx-form-control-help-text {
        display: block;
    }
`;
//# sourceMappingURL=form-control.styles.js.map